'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default function projectOutputTable() {
    return {
        restrict: 'A',
        template: require('../view/table.html'),
        transclude: false,
        scope: {
            selectedItem: '=?myValue',
            items: '=?myItems',
            type: '@myType',
            filters: '=?myFilters',
            ok: '=?myOk',
            isPaging: '=myPagination',
            isSearch: '=mySearching',
            isFilter: '=myFilter',
            project: '=myProject',
            edit: '=edit',
            changed: '=?myChanged',
        },
        controller: ['$scope', '$utils', 'ProjectOutputService',
            function ($scope, $utils, ProjectOutputService) {

                $scope.select = select;
                $scope.refresh = refresh;
                $scope.dblClick = dblClick;
                $scope.isSelect = isSelect;
                $scope.getItems = getItems;
                $scope.getValue = $utils.getValue;

                init();

                // region Function

                function init() {

                    $scope.columns = [{
                        name: "Ед. изм.",
                        data: "unit.name"
                    }, {
                        name: "Количество",
                        data: "outputPlanVal"
                    }, {
                        name: "Примечание",
                        data: "outputPlanNote"
                    }];

                    $scope.searching = {
                        isSearch: $scope.isSearch,
                        filter: null
                    };

                    $scope.pagination = {
                        isPaging: $scope.isPaging,
                        page: 1,
                        size: $scope.isPaging ? 10 : null,
                        totalPages: null,
                        totalItems: null
                    };

                    $scope.toolbox = {
                        buttons: {
                            create: {
                                show: () => $scope.edit,
                                click: () => {
                                    ProjectOutputService.create({}, $scope.edit).result.then(function (data) {
                                        let item = angular.copy(data);
                                        $scope.items.push(item);
                                        select(item);
                                    });
                                },
                                disabled: () => false,
                            },
                            edit: {
                                show: () => true,
                                click: (item) => {
                                    ProjectOutputService.edit(item, $scope.edit).result.then(function (data) {
                                        angular.copy(data, item);
                                        select(item);
                                    });
                                },
                                disabled: () => !isSelected(),
                            },
                            remove: {
                                show: () => $scope.edit,
                                click: (item) => {
                                    $scope.items.splice($scope.items.indexOf($scope.items.find(it => it.id == item.id)), 1);
                                    $scope.selectedItem = null;
                                },
                                disabled: () => !isSelected(),
                            },
                            refresh: {
                                show: () => false,
                                click: $scope.refresh,
                                disabled: () => false,
                            },
                        }
                    };
                }

                function refresh() {
                    if (Array.isArray($scope.items)) {
                        if ($scope.items.every(i => i.id != $scope.selectedItem.id)) {
                            select(undefined);
                            $scope.selectedItem = undefined;
                        }
                    }
                }

                function dblClick(item) {
                    switch ($scope.type) {
                        case 'table' :
                            select(undefined);
                            $scope.toolbox.buttons.edit.click(item);
                            break;
                        case 'select' :
                            $scope.ok(item);
                            break;
                    }
                }

                function select(item) {
                    if (!equals($scope.selectedItem, item)) {
                        $scope.selectedItem = item;
                    } else {
                        $scope.selectedItem = undefined;
                    }
                }

                function isSelect(item) {
                    return equals(item, $scope.selectedItem);
                }

                function getItems() {
                    return $scope.items;
                }

                /**
                 * Выбрана ли запись
                 * @returns {boolean}
                 */
                function isSelected() {
                    return $scope.selectedItem != null;
                }

                /**
                 * Проверка элементов на равенство
                 * @param i1
                 * @param i2
                 * @returns {*}
                 */
                function equals(i1, i2) {
                    if (i1 == i2) {
                        return true;
                    }
                    if (i1 != null && i2 != null) {
                        return angular.equals(i1, i2);
                    }
                    return false;
                }

                // endregion

            }]
    };
}